import { createContext, useContext, type Context, type ReactNode } from 'react';
import { useInboxListState } from '../hooks/useInboxListState';

type InboxListValue = ReturnType<typeof useInboxListState>;

/** Survive Vite HMR — new createContext() breaks Provider/consumer identity mid-session. */
const Ctx: Context<InboxListValue | null> =
  (import.meta.hot?.data.inboxListCtx as Context<InboxListValue | null> | undefined) ??
  createContext<InboxListValue | null>(null);
if (import.meta.hot) import.meta.hot.data.inboxListCtx = Ctx;

export function InboxListProvider({ children }: { children: ReactNode }) {
  const value = useInboxListState();
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useInboxList(): InboxListValue {
  const v = useContext(Ctx);
  if (!v) {
    throw new Error('useInboxList requires InboxListProvider');
  }
  return v;
}
